<mat-card class="cmn-flex row">
    <mat-card-title class="flex row">Message Status</mat-card-title>
    <!-- Alert Search Form -->
        <div *ngIf="!displayAdvancedSearch" class="cmn-flex row align-baseline">
            <mat-form-field class="flex">
                <input (keyup)="performBasicSearchBySender(0)" [formControl]="senderControl" appAutofocus matInput type="text" id="searchSenders"/>
                <mat-placeholder>Search Senders</mat-placeholder>
            </mat-form-field>
            <div>
                <button (click)="initializeAdvancedSearch();" [disabled]="buttonsDisabled" id="advancedSearch" class="mat-raised-button mat-primary" mat-button>Advanced Search
                </button>
            </div>
        </div>
        <div *ngIf="!displayAdvancedSearch">
            <em><small>Searches are performed up to 8 days in the past.</small></em>
        </div>
        <div *ngIf="displayAdvancedSearch">
            <div class="cmn-flex row gutters align-baseline">
                <mat-form-field class="flex">
                    <input [formControl]="senderControl" appAutofocus matInput type="text" id="senderSendersName"/>
                    <mat-placeholder>Search Senders</mat-placeholder>
                </mat-form-field>
                <div>
                    <button (click)="initializeBasicSearch();" [disabled]="buttonsDisabled" id="basicSearch" class="mat-raised-button mat-primary" mat-button>Basic Search
                    </button>
                </div>
            </div>
            <div class="cmn-flex row">
                <mat-form-field class="flex">
                    <input (keyup.enter)="performAdvancedSearch(0)" [formControl]="recipientControl" matInput type="text" id=">searchRecipients"/>
                    <mat-placeholder>Search Recipients</mat-placeholder>
                </mat-form-field>
            </div>
            <div class="cmn-flex row gutters-lg">
                <mat-form-field class="flex">
                    <input (keyup.enter)="performAdvancedSearch(0)" [formControl]="fromDateControl"
                           [matDatepicker]="pickerFrom"
                           id="fromDate" class="date-field"
                           matInput readonly>
                    <mat-datepicker-toggle [for]="pickerFrom" class="color-white-when-dark-mode" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #pickerFrom></mat-datepicker>
                    <mat-hint>From</mat-hint>
                    <mat-hint align="end"><a (click)="clearDateField(1)" class="clear-text" id="clearFrom">Clear From</a></mat-hint>
                    <mat-error *ngIf="fromDateControl.hasError('required')">You must make a entry</mat-error>
                </mat-form-field>
                <mat-form-field class="flex">
                    <input (keyup.enter)="performAdvancedSearch(0)" [formControl]="toDateControl"
                           [matDatepicker]="pickerTo"
                           id="toDate" class="date-field" matInput readonly>
                    <mat-datepicker-toggle [for]="pickerTo" class="color-white-when-dark-mode" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #pickerTo></mat-datepicker>
                    <mat-hint>To</mat-hint>
                    <mat-hint align="end"><a (click)="clearDateField(2)" class="clear-text" id="clearTo">Clear To</a></mat-hint>
                    <mat-error *ngIf="toDateControl.hasError('required')">You must make a entry</mat-error>
                </mat-form-field>
            </div>
            <div *ngIf="dateWarning">
                <em><small>Please Note: Selecting extended date ranges may drastically slow down search response
                    time.</small></em>
            </div>
            <div class="cmn-flex row">
                <mat-form-field class="flex">
                    <input (keyup.enter)="performAdvancedSearch(0)" [formControl]="messageContentControl" matInput
                           type="text" id="messageContent"/>
                    <mat-placeholder>Filter based on message content</mat-placeholder>
                </mat-form-field>
            </div>
            <div class="cmn-flex row gutters-lg">
                <mat-form-field class="flex">
                    <mat-select [formControl]="groupTypeControl">
                        <mat-option [value]="">
                            All
                        </mat-option>
                        <mat-option *ngFor="let groupType of groupTypes" [value]="groupType.group_type">
                            {{groupType.group_type}}
                        </mat-option>
                    </mat-select>
                    <mat-placeholder>Filter by Group Type</mat-placeholder>
                </mat-form-field>
                <mat-form-field class="flex">
                    <mat-select [formControl]=" acknowledgementStateControl">
                        <mat-option *ngFor="let messageState of messageStates" [value]="messageState.toString()">
                            {{getTypeCase(messageState.toString())}}
                        </mat-option>
                    </mat-select>
                    <mat-placeholder>Filter by Escalation State</mat-placeholder>
                </mat-form-field>
            </div>
            <div class="cmn-flex row gutters-lg">
                <label for="showMessagesNOTFromSVCControl">
                    <input type="checkbox" id="showMessagesNOTFromSVCControl" [formControl]="showMessagesNOTFromSVCControl">
                    Show Messages Not Sent By Service Accounts
                </label>
            </div>
            <div class="bottom-buttons">
                <button (click)="performAdvancedSearch(0);" [disabled]="buttonsDisabled"
                        class="mat-raised-button mat-primary"
                        mat-button
                        placeholder="Search" id="adv-Search"> Search
                </button>
                <button (click)="resetAdvancedSearchCriteria();" [disabled]="buttonsDisabled" class="mat-raised-button mat-primary"
                        mat-button
                        placeholder="Search" id="resetAdv-Search"> Reset Search Criteria
                </button>
            </div>
        </div>

</mat-card>
<!-- Sent Alerts Datatable -->
<br>
<app-hourglass *ngIf="!alerts || hourglass"></app-hourglass>
<div *ngIf="alerts" class="full-width" id="alerts">
    <ngx-datatable #alertTable
        class="material"
        (activate)="openAlertDetail($event)"
        (page)="pageChanged($event)"
        (sort)="sortChanged($event)"
        [columns]="alertColumns"
        [columnMode]="'flex'"
        [rows]="alerts"
        [rowHeight]="30"
        [rowClass]="getRowColor"
        [footerHeight]="25"
        [count]="page.count"
        [limit]="page.limit"
        [offset]="page.offset"
        [externalPaging]="true"
        [scrollbarH]="getShowScrollbar(alertTable)"
        [scrollbarV]="false">
        <ngx-datatable-column name="Ack." [flexGrow]="0.5" [minWidth]="25" [sortable]="false">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                <div *ngIf="row.responseRequired" class="acknowledgement">
                    <span *ngIf="row.acceptedCount" class="accept-count">{{row.acceptedCount}}
                        <mat-icon class="thumb-up">thumb_up</mat-icon></span>
                    <span *ngIf="row.declinedCount" class="decline-count">{{row.declinedCount}}
                        <mat-icon class="thumb-down">thumb_down</mat-icon></span>
                </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="From" [flexGrow]="1.25" [minWidth]="100">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="To" [flexGrow]="1.25" [minWidth]="100" [sortable]="false">
            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                <mat-icon *ngIf="isError(row)" class="webhook-error">error_outline</mat-icon>
                {{ value }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Message" [flexGrow]="4" [minWidth]="200" [sortable]="false">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ unicodeToText(value) }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Sent" [flexGrow]="1" [minWidth]="100">
            <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value | date:'M/d/y h:mm a' }}
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>
